<template>
    <v-container>
        <v-overlay :value="isLoading">
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================= -->
        <v-card>
            <v-card-title class="blue lighten-3">グラフ設定</v-card-title>
            <v-card-text>
                <v-simple-table dense>
                    <template v-slot:default>
                        <tbody>
                            <tr class="text-center">
                                <th width="33%"></th>
                                <th width="33%">Min</th>
                                <th width="33%">Max</th>
                            </tr>
                            <tr class="text-center">
                                <td>電圧(V)</td>
                                <td><v-text-field type="number" v-model="chartRange.battery.min" /></td>
                                <td><v-text-field type="number" v-model="chartRange.battery.max" /></td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
        </v-card>
        <v-divider class="ma-3"></v-divider>
        <v-btn block color="success" @click="saveRange()">OK</v-btn>
        <!-- ============================================= -->
    </v-container>
</template>

<script>
export default {
    name: "ChartSetting",
    components: {},
    //========================================================
    data() {
        return {
            //--------------------------
            jwt: "",
            myInfo: [],
            isLoading: false,
            //--------------------------
            chartRange: {
                battery: { min: 0, max: 20 },
            },
            //--------------------------
        };
    },
    //========================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //-----------------------
        this.isLoading = true;
        //-----------------------
        await new Promise((r) => setTimeout(r, 1000));
        if (this.$localStorage.get("chart.range.json") != undefined) {
            Object.assign(this.chartRange, JSON.parse(this.$localStorage.get("chart.range.json")));
        }
        //-----------------------
        this.isLoading = false;
        //-----------------------
        window.scrollTo(0, 0);
    },
    //========================================================
    methods: {
        async saveRange() {
            this.isLoading = true;
            this.$localStorage.set("chart.range.json", JSON.stringify(this.chartRange));
            await new Promise((r) => setTimeout(r, 1000));
            this.isLoading = false;
        },
    },
    //========================================================
};
</script>
